@if (!commonDataService.isOneTime && reply.noteIds && reply.noteIds.length) {
    <app-note-link-line [noteIds]="reply.noteIds" [ticket]="ticket"> </app-note-link-line>
}

@if (reply.reminder) {
    <div class="reminder-alert">
        <app-reply-reminder-alert
            [reminder]="reply.reminder"
            (removeReminderClick)="onRemoveReminderClick()"></app-reply-reminder-alert>
    </div>
}

<div class="ticket-message reply" [ngClass]="{ 'one-time': commonDataService.isOneTime }">
    <div class="d-flex flex-row justify-content-start align-items-start">
        <sb-user-avatar
            class="pointer"
            (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })"
            [user]="reply.author"
            [isNeedTooltip]="false"
            [withLabel]="true">
        </sb-user-avatar>

        <div class="d-flex flex-column justify-content-center align-items-start flex-fill">
            <div class="full-width" layout="row">
                <div layout="column" flex>
                    <div class="d-flex justify-content-between right-angle-info-container">
                        <a (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })">
                            {{ reply.author.name || reply.author.email }}
                        </a>
                        <div class="right-angle-info">
                            <small class="text-light">
                                {{ reply.creationTime | ticketEmailTime }}
                            </small>
                            @if (!commonDataService.isOneTime && !reply.isDraft && !commonDataService.user.isReadOnly) {
                                <span
                                    class="reply-menu"
                                    dropdown
                                    container="body"
                                    [dropup]="isReplyMenuDropUp"
                                    [placement]="!isReplyMenuDropUp ? 'bottom right' : 'top right'">
                                    <div
                                        [tooltip]="'Copied' | translate"
                                        placement="bottom"
                                        #copiedTooltip="bs-tooltip"
                                        [tooltipFadeDuration]="1000"
                                        [triggers]="''"
                                        container="body">
                                        <button
                                            #replyMenuBtn
                                            class="btn btn-icon btn-transparent print-hidden"
                                            dropdownToggle
                                            type="button"
                                            aria-controls="dropdown-basic">
                                            <sb-inline-svg
                                                class="icon"
                                                aria-label="My icon"
                                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                                            </sb-inline-svg>
                                        </button>
                                    </div>

                                    <ul
                                        id="dropdown-basic"
                                        *dropdownMenu
                                        class="dropdown-menu dropdown-menu-right"
                                        role="menu"
                                        aria-labelledby="button-basic">
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="parent.openAddTagsModal(reply)"
                                                translate>
                                                Add tags
                                            </button>
                                        </li>
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="parent.openNoteEditor(reply)"
                                                translate>
                                                Add note
                                            </button>
                                        </li>
                                        @if (
                                            isInboxElementVisible(
                                                commonDataService.customerSettings?.inboxElementsVisibility
                                                    ?.ticketHeader?.forwardAction
                                            )
                                        ) {
                                            <li role="menuitem">
                                                <button
                                                    class="dropdown-item"
                                                    data-testid="forward-message-action"
                                                    type="button"
                                                    (click)="
                                                        forwardMessageService.openForwardForm(
                                                            reply,
                                                            forwardEntityTypeEnum.reply,
                                                            ticket
                                                        )
                                                    "
                                                    translate>
                                                    Forward message
                                                </button>
                                            </li>
                                        }
                                        @if (ticket.constraints.isContentHidingAllowed) {
                                            @if (!reply.isContentHiddenForClient) {
                                                <li role="menuitem">
                                                    <button
                                                        class="dropdown-item"
                                                        type="button"
                                                        (click)="openHideContentPanel()"
                                                        translate>
                                                        Hide content
                                                    </button>
                                                </li>
                                            }
                                            @if (
                                                reply.isContentHiddenForClient || reply.hasContentPartHiddenForClient
                                            ) {
                                                <li role="menuitem">
                                                    <button
                                                        class="dropdown-item"
                                                        type="button"
                                                        (click)="deleteHiddenContent()"
                                                        translate>
                                                        Restore hidden content
                                                    </button>
                                                </li>
                                            }
                                        }
                                        @if (reply.id) {
                                            <li role="menuitem">
                                                <button
                                                    type="button"
                                                    class="dropdown-item"
                                                    ngxClipboard
                                                    [cbContent]="replyUrl"
                                                    (click)="copiedTooltip.show(); copiedTooltip.hide()"
                                                    translate>
                                                    Copy link
                                                </button>
                                            </li>
                                        }
                                        @if (!reply.isDeleted) {
                                            <li
                                                role="menuitem"
                                                dropdown
                                                triggers="mouseover"
                                                container="body"
                                                class="dropstart"
                                                [placement]="!isReminderMenuDropUp ? 'left top' : 'left bottom'"
                                                [dropup]="isReminderMenuDropUp">
                                                <button
                                                    dropdownToggle
                                                    class="dropdown-item dropdown-toggle"
                                                    type="button"
                                                    (click)="$event.stopPropagation()"
                                                    translate>
                                                    Remind
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu" role="menu" style="right: 0">
                                                    <app-reminder-menu
                                                        [isReminderAdded]="!!reply.reminder"
                                                        (remindClick)="onRemindClick($event)"
                                                        (removeReminderClick)="onRemoveReminderClick()"
                                                        (pickDateAndTimeClick)="
                                                            openReminderModal()
                                                        "></app-reminder-menu>
                                                </ul>
                                            </li>
                                        }
                                    </ul>
                                </span>
                            }
                        </div>
                    </div>
                    @if (!isToAndCcHidden) {
                        <div class="text-emails text-light">
                            {{ 'To:' | translate }} {{ reply.emailInfo.to | join }}
                            <button
                                class="btn btn-icon ms-1"
                                [popover]="emailEnvelopeTemplate"
                                [outsideClick]="true"
                                tooltip="{{ 'Show details' | translate }}">
                                <span class="add-arrow"></span>
                            </button>
                            <ng-template #emailEnvelopeTemplate>
                                <div>
                                    @if (reply.emailInfo.fromAddress) {
                                        <div>
                                            <span class="email-info-title" translate>From:</span>
                                            <span class="email-info-content">
                                                {{ reply.emailInfo.fromAddress }}
                                            </span>
                                        </div>
                                    }
                                    <div>
                                        <span class="email-info-title" translate>To:</span>
                                        <span class="email-info-content">{{ reply.emailInfo.to | join }}</span>
                                    </div>
                                    @if (reply.emailInfo.cc?.length) {
                                        <div>
                                            <span class="email-info-title" translate>Cc:</span>
                                            <span class="email-info-content">{{ reply.emailInfo.cc | join }} </span>
                                        </div>
                                    }
                                    @if (reply.emailInfo.bcc?.length) {
                                        <div>
                                            <span class="email-info-title" translate>Bcc:</span>
                                            <span class="email-info-content">{{ reply.emailInfo.bcc | join }} </span>
                                        </div>
                                    }
                                    <div>
                                        <span class="email-info-title" translate>Date:</span>
                                        <span class="email-info-content">
                                            {{ reply.creationTime | date: 'dd.MM.yyyy HH:mm' }}</span
                                        >
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    }

                    <br />
                    @if (!reply.editingReply) {
                        <div
                            class="break-word message-html-content"
                            sbInlineImagePreview
                            appInlineImageLimitWidth
                            [ngClass]="{ 'sb-hidden-content-part': reply.isContentHiddenForClient }"
                            [innerHTML]="reply.message | hideContent | prepareMessage | replaceEmojis: true"></div>
                    }

                    @for (attachment of reply.contentAttachments; track attachment) {
                        <sb-file-view
                            [attachment]="attachment"
                            [permalink]="ticket.permalink"
                            [reply]="reply"
                            [isFilePreviewInModal]="true"
                            [canBeShared]="
                                !commonDataService.isOneTime &&
                                !reply.isDraft &&
                                !commonDataService.user.isReadOnly &&
                                isInboxElementVisible(
                                    commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader
                                        ?.forwardAction
                                )
                            "
                            (forwardFile)="
                                forwardMessageService.openForwardForm(
                                    { message: {}, attachments: [$event] },
                                    forwardEntityTypeEnum.attachment,
                                    ticket
                                )
                            ">
                        </sb-file-view>
                    }

                    @if (!reply.editingReply && reply.notContentAttachments && reply.notContentAttachments.length) {
                        <div class="attachments-block">
                            @for (attachment of reply.notContentAttachments; track attachment; let idx = $index) {
                                <sb-file-preview
                                    class="file-container"
                                    [attachments]="reply.notContentAttachments"
                                    [attachment]="attachment"
                                    [fileIndex]="idx"
                                    [permalink]="ticket.permalink"
                                    [reply]="reply"
                                    (forwardFile)="
                                        forwardMessageService.openForwardForm(
                                            { message: {}, attachments: [$event] },
                                            forwardEntityTypeEnum.attachment,
                                            ticket
                                        )
                                    "
                                    [canBeShared]="
                                        !commonDataService.isOneTime &&
                                        !reply.isDraft &&
                                        !commonDataService.user.isReadOnly &&
                                        isInboxElementVisible(
                                            commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader
                                                ?.forwardAction
                                        )
                                    ">
                                </sb-file-preview>
                            }
                            <div class="clearfix"></div>
                        </div>
                    }

                    @if (reply.hasOriginalMessage) {
                        <div class="original-message">
                            <a (click)="showOriginalMessage(ticket.id, reply.id)">
                                <small><span translate>Show original message</span></small>
                            </a>
                        </div>
                    }

                    @if (reply.editingReply) {
                        <div class="mb-1">
                            @if (!isToAndCcHidden) {
                                <div class="reply-emails-block">
                                    <div class="submitted d-flex flex-row align-items-start">
                                        @if (!commonDataService.isOneTime) {
                                            <label class="label-as-container">
                                                <span class="title me-2" translate>To:</span>

                                                @if (reply.isDraft) {
                                                    <app-tags-input
                                                        class="flex-fill tags-container me-1"
                                                        identifyBy="email"
                                                        placeholder="{{
                                                            'Who do you want to send this reply to?' | translate
                                                        }}"
                                                        displayBy="label"
                                                        [separatorKeys]="separatorKeys"
                                                        [noResultMessage]="
                                                            'This recipient is unknown to us.' | translate
                                                        "
                                                        [selectedItems]="selectedToUsers"
                                                        [items]="users"
                                                        [addOnBlur]="true"
                                                        [contentType]="'users'"
                                                        [addingValidator]="isEmailValid"
                                                        [isNotFromListAllowed]="true"
                                                        [typeaheadGroupField]="'typeName'"
                                                        (add)="
                                                            recipientsUpdate.next({
                                                                to: selectedToUsers,
                                                                cc: selectedCcUsers,
                                                                bcc: selectedBccUsers,
                                                            })
                                                        "
                                                        (delete)="
                                                            recipientsUpdate.next({
                                                                to: selectedToUsers,
                                                                cc: selectedCcUsers,
                                                                bcc: selectedBccUsers,
                                                            })
                                                        ">
                                                    </app-tags-input>
                                                }
                                            </label>

                                            @if (reply.isDraft) {
                                                <button
                                                    class="btn btn-icon"
                                                    ngxClipboard
                                                    [cbContent]="selectedToUsers | arrayToString: 'email'">
                                                    <sb-inline-svg
                                                        class="icon"
                                                        aria-label="My icon"
                                                        [url]="
                                                            '/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'
                                                        "
                                                        [tooltip]="'Copied' | translate"
                                                        [tooltipFadeDuration]="1000"
                                                        [triggers]="''"
                                                        #selectedToUsersTooltip="bs-tooltip"
                                                        (click)="
                                                            selectedToUsersTooltip.show(); selectedToUsersTooltip.hide()
                                                        "
                                                        container="body">
                                                    </sb-inline-svg>
                                                </button>
                                            }
                                        } @else {
                                            <span class="title me-2" translate>To:</span>
                                            <span class="send-to-email">
                                                {{ ticket.firstMessageCreator.name }}
                                            </span>
                                        }

                                        <div class="email-controls-container d-flex align-items-center">
                                            <a
                                                [hidden]="
                                                    isShowCcFieldForDraft || ticket.defaultReplyRecipients.cc.length
                                                "
                                                [ngClass]="{ 'ms-1': !commonDataService.isOneTime }"
                                                (click)="showAndFocusCcFieldForDraft(reply.id)"
                                                class="email-controls-link">
                                                Cc
                                            </a>
                                            <a
                                                [hidden]="isShowBccFieldForDraft"
                                                [ngClass]="{ 'ms-1': !commonDataService.isOneTime }"
                                                (click)="showAndFocusBccFieldForDraft(reply.id)"
                                                class="email-controls-link">
                                                Bcc
                                            </a>
                                            @if (!commonDataService.isOneTime) {
                                                <a
                                                    [hidden]="isShowFromField"
                                                    (click)="showFromField()"
                                                    class="email-controls-link ms-1">
                                                    From
                                                </a>
                                            }
                                        </div>
                                    </div>
                                    @if (isShowCcFieldForDraft || ticket.defaultReplyRecipients.cc.length) {
                                        <div class="submitted d-flex flex-row align-items-start mt-2">
                                            <label class="label-as-container">
                                                <span class="title me-2" translate>Cc:</span>
                                                <app-tags-input
                                                    class="flex-fill tags-container me-1"
                                                    displayBy="label"
                                                    identifyBy="email"
                                                    placeholder="{{ 'Select users' | translate }}"
                                                    replyId="{{ reply.id }}"
                                                    [selectedItems]="selectedCcUsers"
                                                    [contentType]="'users'"
                                                    [items]="users"
                                                    [addOnBlur]="true"
                                                    [noResultMessage]="'This recipient is unknown to us.' | translate"
                                                    [addingValidator]="isEmailValid"
                                                    [separatorKeys]="separatorKeys"
                                                    [isNotFromListAllowed]="true"
                                                    [typeaheadGroupField]="'typeName'"
                                                    (add)="
                                                        recipientsUpdate.next({
                                                            to: selectedToUsers,
                                                            cc: selectedCcUsers,
                                                            bcc: selectedBccUsers,
                                                        })
                                                    "
                                                    (delete)="
                                                        recipientsUpdate.next({
                                                            to: selectedToUsers,
                                                            cc: selectedCcUsers,
                                                            bcc: selectedBccUsers,
                                                        })
                                                    ">
                                                </app-tags-input>
                                            </label>

                                            <button
                                                class="btn btn-icon"
                                                ngxClipboard
                                                [cbContent]="selectedCcUsers | arrayToString: 'email'">
                                                <sb-inline-svg
                                                    class="icon"
                                                    aria-label="My icon"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'
                                                    "
                                                    [tooltip]="'Copied' | translate"
                                                    [tooltipFadeDuration]="1000"
                                                    [triggers]="''"
                                                    #selectedCcUsersTooltip="bs-tooltip"
                                                    (click)="
                                                        selectedCcUsersTooltip.show(); selectedCcUsersTooltip.hide()
                                                    "
                                                    container="body">
                                                </sb-inline-svg>
                                            </button>
                                        </div>
                                    }

                                    @if (isShowBccFieldForDraft) {
                                        <div class="submitted d-flex flex-row align-items-start mt-2">
                                            @if (!commonDataService.isOneTime) {
                                                <label class="label-as-container">
                                                    <span class="title me-2" translate>Bcc:</span>

                                                    @if (reply.isDraft) {
                                                        <app-tags-input
                                                            class="flex-fill tags-container me-1"
                                                            identifyBy="email"
                                                            displayBy="label"
                                                            placeholder="{{ 'Select users' | translate }}"
                                                            replyId="{{ reply.id }}"
                                                            [separatorKeys]="separatorKeys"
                                                            [noResultMessage]="
                                                                'This recipient is unknown to us.' | translate
                                                            "
                                                            [selectedItems]="selectedBccUsers"
                                                            [items]="users"
                                                            [addOnBlur]="true"
                                                            [contentType]="'users'"
                                                            [addingValidator]="isEmailValid"
                                                            [isNotFromListAllowed]="true"
                                                            [typeaheadGroupField]="'typeName'"
                                                            (add)="
                                                                recipientsUpdate.next({
                                                                    to: selectedToUsers,
                                                                    cc: selectedCcUsers,
                                                                    bcc: selectedBccUsers,
                                                                })
                                                            "
                                                            (delete)="
                                                                recipientsUpdate.next({
                                                                    to: selectedToUsers,
                                                                    cc: selectedCcUsers,
                                                                    bcc: selectedBccUsers,
                                                                })
                                                            ">
                                                        </app-tags-input>
                                                    }
                                                </label>

                                                @if (reply.isDraft) {
                                                    <button
                                                        class="btn btn-icon"
                                                        ngxClipboard
                                                        [cbContent]="selectedToUsers | arrayToString: 'email'">
                                                        <sb-inline-svg
                                                            class="icon"
                                                            aria-label="My icon"
                                                            [url]="
                                                                '/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'
                                                            "
                                                            [tooltip]="'Copied' | translate"
                                                            [tooltipFadeDuration]="1000"
                                                            [triggers]="''"
                                                            #selectedToUsersTooltip="bs-tooltip"
                                                            (click)="
                                                                selectedToUsersTooltip.show();
                                                                selectedToUsersTooltip.hide()
                                                            "
                                                            container="body">
                                                        </sb-inline-svg>
                                                    </button>
                                                }
                                            }
                                        </div>
                                    }

                                    @if (isShowFromField) {
                                        <div class="submitted d-flex flex-row align-items-start mt-2">
                                            <label class="label-as-container">
                                                <span class="title me-2" translate>From:</span>
                                                <ng-template #customItemTemplate let-model="item" let-index="index">
                                                    <div class="d-flex align-items-center mt-1 mb-1">
                                                        <div class="truncate">
                                                            <div class="truncate text-light">
                                                                <span class="truncate-name">
                                                                    {{ model | truncate: 33 }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                                <div
                                                    class="tags-input-container form-control d-flex flex-wrap me-1"
                                                    [ngClass]="{ 'ng-invalid': '' }">
                                                    @if (selectedOutboundEmailAddresses.length) {
                                                        <div class="tag truncate">
                                                            <span class="tag-text truncate">{{
                                                                selectedOutboundEmailAddresses[0]
                                                            }}</span>
                                                            <sb-inline-svg
                                                                class="icon icon-close"
                                                                role="button"
                                                                [attr.aria-label]="'Remove email' | translate"
                                                                (click)="removeOutboundEmailAddress()"
                                                                [url]="
                                                                    '/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'
                                                                ">
                                                            </sb-inline-svg>
                                                        </div>
                                                    } @else {
                                                        <input
                                                            #outboundEmailAddressSelector="ngModel"
                                                            autocomplete="off"
                                                            class="typeahead-input"
                                                            [placeholder]="'Outbound email address' | translate"
                                                            [typeaheadMinLength]="0"
                                                            [typeaheadSelectFirstItem]="false"
                                                            [typeaheadIsFirstItemActive]="false"
                                                            [typeahead]="commonDataService.outboundEmailAddresses"
                                                            [typeaheadScrollable]="true"
                                                            [typeaheadOptionsInScrollableView]="4"
                                                            [typeaheadItemTemplate]="customItemTemplate"
                                                            [(ngModel)]="selectedOutboundEmailAddress"
                                                            (typeaheadOnSelect)="addOutboundEmailAddress($event)"
                                                            (keydown)="keyDownHandler($event)"
                                                            (blur)="checkAndAddNewEmail()"
                                                            maxlength="1000" />
                                                    }
                                                </div>
                                            </label>
                                        </div>
                                    }
                                </div>
                            }
                            <div class="smile-field-container">
                                @if (
                                    !commonDataService.isOneTime &&
                                    replyTemplateService.allReplyTemplates.length &&
                                    parent.quillEditors['reply' + reply.id]
                                ) {
                                    <sb-quill-reply-templates
                                        [quillEditor]="parent.quillEditors['reply' + reply.id]"
                                        [reply]="ticket.constraints.areReplyAttachmentsAllowed ? reply : null">
                                    </sb-quill-reply-templates>
                                }

                                <app-web-reply-quill-editor
                                    [id]="'ticket-web-reply-editor-' + reply.id"
                                    [reply]="reply"
                                    (replyChanged)="onReplyChanged(reply.message)"
                                    (editorCreated)="parent.onEditorCreated($event, 'reply' + reply.id)">
                                </app-web-reply-quill-editor>

                                <!--                            @todo replace 'quillEditor' with 'parent.quillEditors['reply' + reply.id]' in parent.updateQuillSelection() -->
                                <sb-quill-emoji-picker
                                    (updateQuillSelection)="parent.updateQuillSelection(quillEditor)"
                                    (emojiSelect)="
                                        parent.replyTemplateManagerService.chooseReplyTemplate({
                                            $event: $event.$event,
                                            templateText: $event.emoji,
                                            quillEditor: parent.quillEditors['reply' + reply.id],
                                            quillRange: parent.quillRange,
                                            isSmile: true,
                                        })
                                    ">
                                </sb-quill-emoji-picker>
                            </div>
                            <div class="attachments-block mb-2">
                                @for (attachment of reply.attachments; track attachment; let idx = $index) {
                                    <sb-file-preview
                                        class="file-container"
                                        [attachment]="attachment"
                                        [fileIndex]="idx"
                                        [canBeRemoved]="true"
                                        [attachments]="reply.attachments"
                                        [permalink]="ticket.permalink"
                                        [reply]="reply"
                                        [canBeShared]="false">
                                    </sb-file-preview>
                                }
                                <div class="clearfix"></div>
                            </div>

                            @if (ticket.isTicketCanBeReplied) {
                                <div
                                    class="d-flex justify-content-end"
                                    [ngClass]="{
                                        'justify-content-between':
                                            commonDataService.community === 'demo' ||
                                            commonDataService.community === 'berghansen',
                                    }">
                                    @if (
                                        commonDataService.community === 'demo' ||
                                        commonDataService.community === 'berghansen'
                                    ) {
                                        <div class="mt-2">
                                            @if (!commonDataService.isOneTime) {
                                                <label
                                                    class="checkbox__label checkbox__label--size-small min-width-50"
                                                    for="isLogged"
                                                    tooltip="{{
                                                        'This email will be logged on the contact record with the same email in your CRM'
                                                            | translate
                                                    }}">
                                                    {{ 'Log' | translate }}
                                                    <input
                                                        type="checkbox"
                                                        id="isLogged"
                                                        name="isLogged"
                                                        [(ngModel)]="reply.isLogged" />
                                                    <span class="checkbox__checkmark"></span>
                                                </label>
                                            }
                                        </div>
                                    }

                                    <div class="buttons-panel mt-0 text-end mb-2">
                                        @if (!commonDataService.isOneTime) {
                                            <button
                                                class="btn btn-icon"
                                                (click)="
                                                    parent.openReplyTemplatesModal(
                                                        $event,
                                                        parent.quillEditors['reply' + reply.id],
                                                        ticket.constraints.areReplyAttachmentsAllowed ? reply : null
                                                    )
                                                "
                                                tooltip="{{ 'Insert a saved template' | translate }}"
                                                container="body">
                                                <sb-inline-svg
                                                    class="icon"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'
                                                    ">
                                                </sb-inline-svg>
                                            </button>
                                        }
                                        @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed) {
                                            <button
                                                class="btn btn-icon"
                                                (click)="
                                                    parent.openAttachmentsModal(
                                                        reply.attachments,
                                                        reply.attachments.length,
                                                        ticket.constraints.maxReplyAttachmentsCount
                                                    )
                                                "
                                                tooltip="{{ 'Attachments' | translate }}"
                                                container="body">
                                                <sb-inline-svg
                                                    class="icon"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'
                                                    ">
                                                </sb-inline-svg>
                                            </button>
                                        }
                                        @if (reply.isDraft && !commonDataService.isOneTime) {
                                            <button
                                                class="btn mt-1 mb-1 btn-outline"
                                                [disabled]="
                                                    reply.isSendingReply ||
                                                    (reply.message
                                                        | isInvalidMessage
                                                            : ticket.constraints
                                                            : !!reply.attachments.length
                                                            : true)
                                                "
                                                (click)="
                                                    parent.doneEditing(
                                                        null,
                                                        reply,
                                                        false,
                                                        true,
                                                        selectedCcUsers,
                                                        selectedBccUsers,
                                                        selectedToUsers,
                                                        undefined,
                                                        undefined,
                                                        undefined,
                                                        selectedOutboundEmailAddresses[0]
                                                    )
                                                "
                                                translate>
                                                save as draft
                                            </button>
                                        }
                                        @if (
                                            commonDataService.customerSettings.isCustomerReplyPortalEnabled &&
                                            !commonDataService.isOneTime
                                        ) {
                                            <button
                                                [disabled]="
                                                    reply.isSendingReply ||
                                                    !selectedToUsers.length ||
                                                    (reply.message
                                                        | isInvalidMessage
                                                            : ticket.constraints
                                                            : !!reply.attachments.length
                                                            : true)
                                                "
                                                class="btn mt-1 mb-1 btn-reply-link"
                                                (click)="
                                                    parent.doneEditing(
                                                        null,
                                                        reply,
                                                        true,
                                                        false,
                                                        selectedCcUsers,
                                                        selectedBccUsers,
                                                        selectedToUsers,
                                                        null,
                                                        reply.isLogged,
                                                        true,
                                                        selectedOutboundEmailAddresses[0]
                                                    )
                                                ">
                                                <sb-inline-svg
                                                    class="icon ps-0"
                                                    aria-label="Link icon"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'
                                                    ">
                                                </sb-inline-svg>
                                                <span translate>send reply-link </span>
                                            </button>
                                        }
                                        @if (!ticket.constraints.isOnlySendReplyAsLinkAllowed) {
                                            <div class="d-inline-block">
                                                <button
                                                    class="btn btn-outline"
                                                    [disabled]="
                                                        reply.isSendingReply ||
                                                        !selectedToUsers.length ||
                                                        (reply.message
                                                            | isInvalidMessage
                                                                : ticket.constraints
                                                                : !!reply.attachments.length
                                                                : true)
                                                    "
                                                    (click)="
                                                        parent.doneEditing(
                                                            null,
                                                            reply,
                                                            true,
                                                            false,
                                                            selectedCcUsers,
                                                            selectedBccUsers,
                                                            selectedToUsers,
                                                            null,
                                                            reply.isLogged,
                                                            undefined,
                                                            selectedOutboundEmailAddresses[0]
                                                        )
                                                    "
                                                    translate>
                                                    send
                                                </button>
                                            </div>
                                        }
                                        <button class="btn btn-outline" (click)="parent.deleteReply(reply)" translate>
                                            cancel
                                        </button>
                                    </div>
                                </div>
                            }
                            <div class="clearfix"></div>
                        </div>
                    }

                    <small class="text-light d-flex align-items-center flex-wrap">
                        @if (reply.isDraft) {
                            <span>
                                <span class="label label-warning mb-1">
                                    <sb-inline-svg
                                        class="icon icon-pri icon-sm"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'">
                                    </sb-inline-svg>
                                    <span translate>DRAFT</span></span
                                >
                                @if (reply.tags.length) {
                                    <span class="text-light">&nbsp;·&nbsp;</span>
                                }
                            </span>
                        }
                        @if (reply.tags?.length) {
                            <app-tags [ticketId]="ticket.id" [tags]="reply.tags"></app-tags>
                        }
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>
